var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"script-container",class:_vm.withHtml},[(_vm.html)?_c('div',{staticClass:"script-wrapper",domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e(),_c('div',{ref:"script",staticClass:"script"})])}
var staticRenderFns = []

export { render, staticRenderFns }